<template>
  <el-dialog
      :title="question.id?'编辑试题':'添加试题'"
      @open="init"
      @close="doReset"
      :destroy-on-close="true"
      :append-to-body="true"
      :visible.sync="visible"
      :modal-append-to-body="true"
      width="880px">
    <div class="question-save-page">
      <el-form :model="info" label-width="60px" size="small" label-position="right">
        <el-form-item label="题目:" prop="title" :rules="[{ required: true, message: '请输入试题标题', trigger: 'blur' }]">
          <el-input v-model="info.title"/>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="类型:">
              <el-select v-model="info.type" placeholder="请选择" @change="chgType">
                <el-option label="单选" :value="1"></el-option>
                <el-option label="多选" :value="2"></el-option>
                <el-option label="双选" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维度:">
              <el-input v-model="info.degree" />
            </el-form-item>
          </el-col>
        </el-row>
        <table class="table table-bordered margin-tb-10 option-table">
          <tr class="bg-light-cyan">
            <th width="45">选项</th>
            <th>题目</th>
            <th width="80">分数</th>
            <th width="160">维度</th>
            <th width="100">操作</th>
          </tr>
          <tr v-for="i in options.length" :key="i">
            <td style="vertical-align: middle"> {{ String.fromCharCode(64+i)}} </td>
            <td> <el-input v-model="options[i-1].name" size="small"></el-input></td>
            <td> <el-input-number v-model="options[i-1].score" :min="0" :max="100" label="分数" size="small"></el-input-number></td>
            <td> <el-input v-model="options[i-1].degree" size="small"></el-input></td>
            <td valign="middle">
              <el-button icon="el-icon-circle-plus-outline" size="small" @click="options.push({})" />
              <el-button icon="el-icon-remove-outline" size="small" @click="options.splice(i - 1, 1)" v-if="i > 2" />
            </td>
          </tr>
        </table>

      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="save()" round><i class="fa fa-save"></i> 保存 </el-button>
      <el-button size="small" @click="doReset()" round><i class="fa fa-close"></i> 关闭 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { save, update } from '@/api/manage/questions'
export default {
  name: 'question-save',
  props: {
    question: {
      type: Object,
      required: true // 必传
    },
    visible:false
  },
  data() {
    return {
      options: [{}],
      info:{
        type:1
      }
    }
  },
  methods: {
    init(){
      if(this.question.id){
        this.info = this.question
        this.options = this.question.optionList || [{name:null,score:null,degree:null}]
      }
    },
    doReset() {
      this.que = {}
      this.info = {}
      this.$emit('done', false)
    },
    save() {
      let que = { ...this.info,...{'paperId':this.question.paperId,'options':this.options}}
      if(this.question.id){
        update(que).then(res => {
          this.$message.success(res.data.message)
          this.$emit('done', true)
        })
      }else{
        save(que).then(res => {
          this.$message.success(res.data.message)
          this.$emit('done', true)
        })
      }
    }
  }
}
</script>

<style lang="scss" type="text/scsss">
.option-table.table tr > th, option-table.table tr > td{
  vertical-align: middle;
}
</style>
